import React from "react";

interface StudentTransferModalsProps {
  showRevertModal: boolean;
  setShowRevertModal: (show: boolean) => void;
  confirmRevert: () => void;
  isReverting: boolean;
}

const StudentTransferModals: React.FC<StudentTransferModalsProps> = ({
  showRevertModal,
  setShowRevertModal,
  confirmRevert,
  isReverting,
}) => {
  return (
    <>
      {/* Revert Modal */}
      {showRevertModal && (
        <div
          className="modal fade show"
          style={{ display: "block" }}
          id="revert-modal"
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <form
                onSubmit={(e) => {
                  e.preventDefault();
                  confirmRevert();
                }}
              >
                <div className="modal-body text-center p-4">
                  <span className="delete-icon mb-3 d-inline-block">
                    <i className="ti ti-arrow-back-up fs-1 text-danger" />
                  </span>
                  <h4>Confirm Revert</h4>
                  <p>
                    Are you sure you want to revert this transfer? This will immediately transfer the student back to their previous center.
                  </p>
                  <div className="d-flex justify-content-center mt-4">
                    <button
                      type="button"
                      className="btn btn-light me-3"
                      onClick={() => setShowRevertModal(false)}
                      disabled={isReverting}
                    >
                      Cancel
                    </button>
                    <button 
                      type="submit" 
                      className="btn btn-danger"
                      disabled={isReverting}
                    >
                      {isReverting ? (
                        <>
                          <span className="spinner-border spinner-border-sm me-2" />
                          Reverting...
                        </>
                      ) : (
                        "Yes, Revert"
                      )}
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}
      {showRevertModal && <div className="modal-backdrop fade show"></div>}
    </>
  );
};

export default StudentTransferModals;
